var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeluser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 20V16.75C0.75 13.9886 2.98858 11.75 5.75 11.75C6.55931 11.75 7.3237 11.9423 8 12.2836M15.7959 19.796L12.614 16.614M12.614 16.614L9.43198 13.432M12.614 16.614L15.7959 13.432M12.614 16.614L9.43198 19.796M9.5 4.5C9.5 6.57107 7.82107 8.25 5.75 8.25C3.67893 8.25 2 6.57107 2 4.5C2 2.42893 3.67893 0.75 5.75 0.75C7.82107 0.75 9.5 2.42893 9.5 4.5Z",
    stroke: "#FFEDEC",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeluser);
export default __webpack_public_path__ + "static/media/deluser.66c658fa44197dfe58f22a134996a7b5.svg";
export { ForwardRef as ReactComponent };